import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Products/ShredProduct.tsx");
